<form class="flex flex-col items-center gap-2 p-2" [formGroup]="form" (ngSubmit)="onSubmit()">
  @if (errorMessage()) {
    <app-reset-password-error [errorMessage]="errorMessage()" />
  }
  <div class="mb-4 w-full">
    <label for="new-password" class="cursor-pointer" i18n="@@resetPasswordNewLabel">New Password</label>
    <div class="relative">
      <input
        [type]="showNewPassword ? 'text' : 'password'"
        id="new-password"
        name="new-password"
        formControlName="newPassword"
        class="reset-input"
        [ngClass]="{
          'reset-input-error': form.controls.newPassword.touched && form.controls.newPassword.invalid,
        }"
        required />
      <i
        class="fas password-eye-icon"
        [class.fa-eye]="!showNewPassword"
        [class.fa-eye-slash]="showNewPassword"
        (click)="showNewPassword = !showNewPassword"></i>
    </div>
    @if (form.controls.newPassword.touched && form.controls.newPassword.invalid) {
      @if (form.controls.newPassword.errors?.["required"]) {
        <p class="mt-1 text-sm text-red-600" i18n="@@resetPasswordNewRequired">Password is required</p>
      } @else if (form.controls.newPassword.errors?.["minlength"]) {
        <p class="mt-1 text-sm text-red-600" i18n="@@resetPasswordNewMinLength">
          Password must be at least 8 characters
        </p>
      } @else if (form.controls.newPassword.errors?.["maxlength"]) {
        <p class="mt-1 text-sm text-red-600" i18n="@@resetPasswordNewMaxLength">
          Password must be at most 50 characters
        </p>
      } @else if (form.controls.newPassword.errors?.["pattern"]) {
        <p class="mt-1 text-sm text-red-600" i18n="@@resetPasswordNewPattern">
          Password must contain at least one digit, one English letter, and one special character (!, &#64;, #, $, %, ^,
          &amp;, *, (, ), [, ], -, _, =, +, /, \, ~, ., &lt;, &gt;, :, ;, &quot;, '). Only English letters are allowed.
        </p>
      }
    }
  </div>

  <div class="mb-4 w-full">
    <label for="confirm-password" class="cursor-pointer" i18n="@@resetPasswordConfirmLabel">Confirm Password</label>
    <div class="relative">
      <input
        [type]="showConfirmPassword ? 'text' : 'password'"
        id="confirm-password"
        name="confirm-password"
        formControlName="confirmPassword"
        class="reset-input"
        [ngClass]="{
          'reset-input-error':
            (form.controls.confirmPassword.touched && form.controls.confirmPassword.invalid) ||
            (form.controls.confirmPassword.touched &&
              form.controls.confirmPassword.valid &&
              form.controls.newPassword.value !== form.controls.confirmPassword.value),
        }"
        required />
      <i
        class="fas password-eye-icon"
        [class.fa-eye]="!showConfirmPassword"
        [class.fa-eye-slash]="showConfirmPassword"
        (click)="showConfirmPassword = !showConfirmPassword"></i>
    </div>
    @if (form.controls.confirmPassword.touched && form.controls.confirmPassword.invalid) {
      @if (form.controls.confirmPassword.errors?.["required"]) {
        <p class="mt-1 text-sm text-red-600" i18n="@@resetPasswordConfirmRequired">Confirm password is required</p>
      }
    } @else if (
      form.controls.confirmPassword.touched &&
      form.controls.confirmPassword.valid &&
      form.controls.newPassword.value !== form.controls.confirmPassword.value
    ) {
      <p class="mt-1 text-sm text-red-600" i18n="@@resetPasswordMismatch">Passwords do not match</p>
    }
  </div>

  <div class="flex w-full justify-end">
    <button type="submit" [disabled]="loading()" class="btn-primary mt-4 px-3 py-2">
      @if (loading()) {
        <span i18n="@@resetPasswordButtonLoading">Resetting...</span>
      } @else {
        <span i18n="@@resetPasswordButtonText">RESET</span>
      }
    </button>
  </div>
</form>
